import React from 'react';
import { noop } from '@prisjakt/ui-base';

import ErrorBoundary from '../../../../components/error-boundary';

import { ProductHeaderProps } from './types';

import * as S from './styles-mobile';

const ProductHeaderMobile = (props: ProductHeaderProps) => {
  const { title, product } = props;

  if (!product) {
    return null;
  }

  return (
    <S.Header>
      <S.MainSection>
        <ErrorBoundary onError={noop}>
          {product && (
            <>
              {props.currentCampaign ? (
                <S.CampaignBadge
                  campaign={props.currentCampaign}
                  size="large"
                />
              ) : null}
              <S.ProductMedia
                name={product.name}
                media={product.media}
                category={product.category}
              />
            </>
          )}
        </ErrorBoundary>
        <S.DescriptionWrapper>
          <S.Title data-test="ProductTitle">{title}</S.Title>

          <S.ProductActionButtons
            product={product}
            buttonStyle="circle"
            horizontal
          />
        </S.DescriptionWrapper>
      </S.MainSection>
    </S.Header>
  );
};

export default ProductHeaderMobile;
